Vue.component('content-blog', {
    delimiters: ['[[', ']]'],
    template: `
        <div>
            <div class="row pt-5 pt-md-0">

                <div class="lqd-column col-md-12">

                    <header class="fancy-title text-center mb-70">
                        <h6 class="text-uppercase">Editorials</h6>
                        <h2><strong>Latest</strong> posts</h2>
                    </header>

                </div><!-- /.lqd-column col-md-12 -->

                <div class="lqd-column col-md-12">

                    <div class="liquid-blog-posts">

                        <div class="liquid-blog-grid row">

                            <div class="lqd-column col-md-4">
                                <article class="liquid-lp">
                                    <figure class="liquid-lp-media rounded">
                                        <a href="#">
                                            <img src="./assets/demo/blog/blog-6.jpg" alt="Blog Post">
                                        </a>
                                    </figure>
                                    <header class="liquid-lp-header">
                                        <h2 class="entry-title liquid-lp-title h5">
                                            <a href="#" rel="bookmark">Kobe Steel plant that supplied plane components being checked</a>
                                        </h2>
                                        <time class="liquid-lp-date font-style-italic size-lg" datetime="2019-08-16T11:33:03+00:00">5 months ago</time>
                                    </header>
                                </article>
                            </div><!-- /.col-md-4 -->

                            <div class="lqd-column col-md-4">
                                <article class="liquid-lp">
                                    <figure class="liquid-lp-media rounded">
                                        <a href="#">
                                            <img src="./assets/demo/blog/blog-7.jpg" alt="Blog Post">
                                        </a>
                                    </figure>
                                    <header class="liquid-lp-header">
                                        <h2 class="entry-title liquid-lp-title h5">
                                            <a href="#" rel="bookmark">Trade Show 2017 promotions</a>
                                        </h2>
                                        <time class="liquid-lp-date font-style-italic size-lg" datetime="2019-08-16T11:32:46+00:00">5 months ago</time>
                                    </header>
                                </article>
                            </div><!-- /.col-md-4 -->

                            <div class="lqd-column col-md-4">
                                <article class="liquid-lp category-news category-rounded">
                                    <figure class="liquid-lp-media rounded">
                                        <a href="#">
                                            <img src="./assets/demo/blog/blog-8.jpg" alt="Blog Post">
                                        </a>
                                    </figure>
                                    <header class="liquid-lp-header">
                                        <h2 class="entry-title liquid-lp-title h5">
                                            <a href="#" rel="bookmark">Believing is the absence of doubt</a>
                                        </h2>
                                        <time class="liquid-lp-date font-style-italic size-lg" datetime="2019-08-16T11:32:32+00:00">5 months ago</time>
                                    </header>
                                </article>
                            </div><!-- /.col-md-4 -->
                            
                        </div><!-- /.liquid-blog-grid -->

                    </div><!-- /.liquid-blog-posts -->

                </div><!-- /.lqd-column col-md-12 -->

            </div><!-- /.row -->
        </div>
    `,
    props: {
        idcomponent: {
            type: String,
            default: 'menu'
        },
    },
    data: function () {
        return {
            menuType: 1,
        }
    },
    mounted(){

    },
    methods: {
        test: function(){

        }
    },
});